import { render, staticRenderFns } from "./CreateItem.vue?vue&type=template&id=6957fb8c"
import script from "./CreateItem.vue?vue&type=script&lang=ts"
export * from "./CreateItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports